import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useGroupInfoQuery } from "../../Slices/circleApiSlice";

import PendingPage from "./PendingPage/PendingPage";
import ActivePage from "./ActivePage/ActivePage";
import CompletedPage from "./CompletedPage/CompletedPage.tsx";
import ErrorPage from "components/Circle/shared/ErrorPage";
import { MoneyLoading } from "components/routers/MoneyLoading";

function CirclePage() {
  const [members] = useState([]);
  const { groupId: routeGroupId } = useParams();

  const { data: group, isLoading } = useGroupInfoQuery(routeGroupId, {});

  if (isLoading) {
    return <MoneyLoading/>;
  }

  if (!group) {
    return <ErrorPage />;
  }

  switch (group.status) {
    case "completed":
      return <CompletedPage groupInfo={group} />;
    case "pending":
      return <PendingPage groupInfo={group} memberList={members} />;
    default:
      return <ActivePage group={group} />;
  }
}

export default CirclePage;
